import { BelShapeFileField } from 'redux/bulkEnquiryLodgement/types';

const POPUP_INFO_SOURCE_FIELD_NAMES = new Set(['popupinfo', 'description']);

export function isPopupInfoSourceField(name: string): boolean {
  return POPUP_INFO_SOURCE_FIELD_NAMES.has(name.toLowerCase());
}

/** Hide KML popup blobs; promoted keys (USER_REF, etc.) are listed separately. */
export function getFileAttributeFieldsForDropdown(
  fields: BelShapeFileField[]
): BelShapeFileField[] {
  return fields.filter((field) => !isPopupInfoSourceField(field.name));
}

export function pickDefaultUserReferenceProperty(
  fields: BelShapeFileField[]
): string {
  const dropdownFields = getFileAttributeFieldsForDropdown(fields);
  if (!dropdownFields.length) {
    return '';
  }
  const preferred = dropdownFields.find(
    (f) =>
      f.name.toUpperCase() === 'USER_REF' ||
      f.name.toLowerCase() === 'user_reference'
  );
  if (preferred) {
    return preferred.name;
  }
  const stringField = dropdownFields.find((f) => f.type === 'string');
  return (stringField || dropdownFields[0]).name;
}
